import React, { useEffect, useState }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import PersonalInfoFields from "./PersonalInfoFields";
import { 
	getUserDetailsDetails, doUserDetailsUpdate, doValidateUserDetails
} from "../../../../redux/userdetails/userDetailsState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { FormatDateValue } from "../../../../utils/index";
import Button from "components/button";
import { API_URL } from '../../../../constants';

const PersonalInfoForm = ({getRecord, doUpdate, recordData, requesting, success, doValidate, farmerId, ...props}) => {
	const { recordId, mode } = props;  	
	const [form] = useForm();
	const [imageUrl, setImageUrl] = useState(null);
	
	useEffect(() => {
		getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { date_of_birth, ...restData } = recordData;
			const initialValues = {
				...restData,
				date_of_birth: date_of_birth ? FormatDateValue(date_of_birth) : null,
				section: 'Personal Information',				
			};
			form.setFieldsValue(initialValues);
			setImageUrl(`${API_URL}/my/avatar/${recordData?.user_id}`);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		try {  
			formData.redirect = false;
			formData.date_of_birth = formData.date_of_birth.format('YYYY-MM-DD');
			doUpdate(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	const doUpdateValidated = () => {
		doValidate({id: recordId });
	};

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
				layout="vertical"
				onFinish={onSubmit}
			>   

				{imageUrl && 
					<div className="w-[100px] h-[100px] mb-3 border">
						<img src={imageUrl} alt="avatar" className="rounded w-full"/>
					</div>
				}

				<PersonalInfoFields recordData={recordData} mode={mode}/>

				<CrudButtons baseRoute="/console/farmer-informations" 
					mode={mode} 
					recordId={farmerId} 
					cancelLabel="Back">
						{!recordData?.is_validated && 
						<Button type="button" 
							className="mx-3 min-w-[100px] text-center"
							onClick={doUpdateValidated}
						>
							Validated
						</Button>
						}
				</CrudButtons>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.userDetails.details?.data,
	requesting: state.userDetails.details?.requesting,
	success: state.userDetails.details?.success,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getUserDetailsDetails(id)),
	doUpdate: (data) => dispatch(doUserDetailsUpdate(data)),
	doValidate: (data) => dispatch(doValidateUserDetails(data)),
	
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoForm);